import {
  ByDateCard,
  ByDateCardVariantEnum,
} from '@app/feature/statistics/components/by-date-card/by-date.card';
import { useCpmsBoGetTransactionReportsCountByMonthQuery } from '@service/cpms-bo-transaction-reports-count-statistics.service';

import { useFilters } from '../../context/filters.context';

export const TransactionsByMonthCard = (): React.JSX.Element => {
  const { transformedFilters } = useFilters();
  const { data } = useCpmsBoGetTransactionReportsCountByMonthQuery({
    ...transformedFilters,
  });

  return (
    <ByDateCard data={data} variant={ByDateCardVariantEnum.Transactions} />
  );
};
